import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b041186"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "space-home" }
const _hoisted_2 = { class: "com-search" }
const _hoisted_3 = { class: "search-icon" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "space-box" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_search, {
        placeholder: "搜索办公区",
        modelValue: _ctx.searchValue,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValue) = $event)),
          _ctx.onSearch
        ],
        onClear: _ctx.onCancel
      }, null, 8, ["modelValue", "onUpdate:modelValue", "onClear"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.parseImgUrl('search-icon', 'search-icon.svg'),
          alt: ""
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.spaceData && _ctx.spaceData.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.spaceData, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["space-item", 
            _ctx.activeSpace.spaceId == item.spaceId ? 'space-active-item' : ''
          ]),
              key: 'spaceItem' + index,
              onClick: ($event: any) => (_ctx.changeSpace(item, index))
            }, [
              _createElementVNode("span", null, _toDisplayString(item.spaceName), 1)
            ], 10, _hoisted_6))
          }), 128))
        : _createCommentVNode("", true)
    ])
  ]))
}